import Vue from 'vue'
import Router from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import AppLayout from '@/layouts/App'
import store from '@/store'
import axios from 'axios';

Vue.use(Router)
const apiUrl = process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : 'https://rp-api.karahan.io/api'
// const apiUrl = 'http://localhost/royal-parking-api/public/api'

const refreshToken = (token, next) => {
  let user = {};
  axios.post(`${apiUrl}/auth/refresh`, {}, {headers: {
    'Authorization': `Bearer ${token}`
  }}).then(response=>{
    user.token = response.data.access_token

    axios.post(`${apiUrl}/auth/super`, {}, { headers: { 'Authorization': `Bearer ${response.data.access_token}` } }).then(meResponse => {
      // User is super user

      user.me = meResponse.data
      store.commit('UPDATE_USER', { user })
      next()
    }).catch(error => {
      // User is user but not superuser
      store.commit('UPDATE_USER', { user: null });
      next('/system/login')
    })
  }).catch(err=>{
    store.commit('UPDATE_USER', { user: null });
    next('/system/login')
  })
}

const router = new Router({
  base: process.env.BASE_URL,
  // mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: 'overzicht',
      component: AppLayout,
      meta: { authRequired: true, hidden: true },
      children: [
        // Dashboards
        {
          path: '/overzicht',
          meta: {
            title: 'Overzicht',
          },
          component: () => import('./views/overzicht'),
        },
        {
          name: 'singleReservation',
          path: '/overzicht/reservering/:reservation_id',
          meta: {
            title: 'Reservering Overzicht',
          },
          component: () => import('./views/overzicht/reservering'),
        },
        {
          name: 'singleOrganization',
          path: '/overzicht/organisatie/:organization_id',
          meta: {
            title: 'Organisatie Overzicht',
          },
          component: () => import('./views/overzicht/organizatie'),
        },
        {
          name: 'facturen',
          path: '/facturen',
          meta: {
            title: 'Facturen',
          },
          component: () => import('./views/facturen'),
        },
        ,
        {
          name: 'boekhouding',
          path: '/boekhouding',
          meta: {
            title: 'Boekhouding',
          },
          component: () => import('./views/boekhouding'),
        },
        {
          name: 'chauffeurs',
          path: '/chauffeurs',
          meta: {
            title: 'Chauffeurs',
          },
          component: () => import('./views/chauffeurs'),
        },

        // Kortingpage

        {
          path: '/kortingen',
          meta: {
            title: 'Kortingen',
          },
          component: () => import('./views/kortingen'),
        },
        {
          path: '/prijstabellen',
          meta: {
            title: 'Prijstabellen',
          },
          component: () => import('./views/prijstabellen'),
        },
        {
          name: 'organizationList',
          path: '/organisaties',
          meta: {
            title: 'Organisaties',
          },
          component: () => import('./views/organizaties'),
        },
        {
          name: 'newReservation',
          path: '/nieuwe-reservering',
          meta: {
            title: 'Nieuwe reservering',
          },
          component: () => import('./views/reservation/newReservation.vue'),
        },
        {
          name: 'reservation-create-personal',
          path: '/reservation-create-personal',
          meta: {
            title: 'Nieuwe reservering',
          },
          component: () => import('./views/reservation/reservationPersonal.vue'),
        },


        // 404
        {
          path: '/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/system/404'),
        },
      ],
    },

    // System Pages
    {
      path: '/system',
      component: AuthLayout,
      redirect: '/system/login',
      children: [
        {
          path: '/system/login',
          meta: {
            title: 'Login',
          },
          component: () => import('./views/system/login'),
        },
        {
          path: '/system/forgot-password',
          meta: {
            title: 'Forgot Password',
          },
          component: () => import('./views/system/forgot-password'),
        },
        {
          path: '/system/register',
          meta: {
            title: 'Register',
          },
          component: () => import('./views/system/register'),
        },
        {
          path: '/system/lockscreen',
          meta: {
            title: 'Lockscreen',
          },
          component: () => import('./views/system/lockscreen'),
        },
        {
          path: '/system/404',
          meta: {
            title: 'Error 404',
          },
          component: () => import('./views/system/404'),
        },
        {
          path: '/system/500',
          meta: {
            title: 'Error 500',
          },
          component: () => import('./views/system/500'),
        },
        {
          path: '/system/401',
          meta: {
            title: 'Error 401',
          },
          component: () => import('./views/system/401'),
        },
      ],
    },

    // Redirect to 404
    {
      path: '*', redirect: 'system/404', hidden: true,
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    if (!store.state.user.user) {
      next({
        path: '/system/login',
        query: { redirect: to.fullPath },
      })
    } else {
      next()
      // axios.post(`${apiUrl}/auth/me`, {}, {headers: {
      //   'Authorization': `Bearer ${store.state.user.user.token  }`
      // }}).then(response=>{
      //   next();
      // }).catch(err=>{
      //   next({
      //     path: '/system/login',
      //     query: { redirect: to.fullPath },
      //   })
        
      // })
      
    }
  } else {
    next()
  }
})

export default router
